import React from 'react'

import Grid from '../../../../components/Grid'
import IconArrowRight from '../../../../components/icons/IconArrowRight'
import IconClose from '../../../../components/icons/IconClose'
import PromotionBarModal from './PromotionBarModal'
import { getVisibilityStatusFromCookie } from './utils/getVisibilityStatusFromCookie'
import { getUserSegmentFromCookie } from './utils/getUserSegmentFromCookie'

const PromotionBar: React.FC = () => {
  const [showPromotionModal, setShowPromotionModal] = React.useState(false)
  const [showPromotionBar, setShowPromotionBar] = React.useState(false)

  React.useEffect(() => {
    const id = getUserSegmentFromCookie()
    const isHidden = getVisibilityStatusFromCookie()
    const isDev = !!location.href.match(/localhost|development/g)

    const experimentStart = new Date(Date.UTC(isDev ? 2021 : 2022, 3, 2, 17, 0, 0)) // 02.04.2022 19:00 CET - mount and hour are zero based
    const experimentEnd = new Date(Date.UTC(isDev ? 2023 : 2022, 3, 9, 20, 59, 0)) // 09.04.2022 22:59 CET - mount and hour are zero based

    const hasMatchingVariant = id > 50
    const hasMatchingTimeFrame = new Date() > experimentStart && new Date() < experimentEnd

    const isBarVisible = hasMatchingVariant && hasMatchingTimeFrame && !isHidden

    setShowPromotionBar(isBarVisible)

    setTimeout(() => {
      window.dataLayer?.push({
        event: 'experiment-initialized',
        experimentId: isDev ? 'dElxwz-aSB-254-UyB2tAA' : 'gA0h5vpcS-GkYBgA7Skj0w',
        variantId: Number(hasMatchingVariant),
      })
      if (isBarVisible) {
        window.dataLayer?.push({
          event: 'eecPromoImpression',
          ecommerce: {
            promoView: {
              promotions: [
                {
                  id: 'free shipping promo bar',
                  name: 'free shipping promo bar',
                  creative: location.pathname,
                },
              ],
            },
          },
        })
      }
    }, 500)
  }, [])

  const handleModalOpenClick = () => {
    window.dataLayer?.push({
      event: 'eecPromoClick',
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: 'free shipping promo bar',
              name: 'free shipping promo bar',
              creative: location.pathname,
            },
          ],
        },
      },
    })
    setShowPromotionModal(true)
  }

  const handleModalCloseClick = () => {
    setShowPromotionModal(false)
  }

  const handlePromotionCloseClick = () => {
    setShowPromotionBar(false)
    document.cookie = `17578_promotion_bar_hidden=true; expires=${getTonight()}; path=/`
  }

  return (
    <>
      {showPromotionBar && (
        <div className="text-white transition-colors duration-200 bg-sale-red" data-testid="promotion-bar">
          <Grid.Container>
            <Grid.Row>
              <Grid.Col className="relative text-center px-24 py-8">
                <div
                  className="flex cursor-pointer justify-center items-center"
                  onClick={handleModalOpenClick}
                  data-testid="promotion-bar-body"
                >
                  Shop it, Love it! <b className="border-b mx-8 whitespace-no-wrap">Gratisversand bis 09.04</b>
                  <IconArrowRight className="w-20 h-20" />
                </div>
                <span className="absolute right-0 -mt-12 cursor-pointer" style={{ top: '50%' }}>
                  <IconClose onClick={handlePromotionCloseClick} />
                </span>
              </Grid.Col>
            </Grid.Row>
          </Grid.Container>
        </div>
      )}
      {showPromotionModal && <PromotionBarModal onCloseClick={handleModalCloseClick} />}
    </>
  )
}

const getTonight = (): Date => {
  const date = new Date()
  const tonight = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 22, 0))
  return new Date(tonight)
}

export default PromotionBar
